<nav aria-label="breadcrumbs" class="breadcrumbs">
    @for(breadcrumb of breadcrumbs$ | async; track breadcrumb){
    <small>
      <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
    </small>
    @if(!$last){
    <small> / </small>

    }}
</nav>